function subscribeToBackInStock(email, variantId){
  console.log('[Klaviyo BIS API] Starting subscription process for variant:', variantId);

  const formattedDate = '2025-04-15';

  const payload = {
    "data": {
      "type": "back-in-stock-subscription",
      "attributes": {
        "profile": {
          "data": {
              "type": "profile",
              "attributes": {
                  "email": email,
              }
          }
        },
        "channels": ["EMAIL"],
      },
      "relationships": {
        "variant": {
          "data": {
            "type": "catalog-variant",
            "id": `$shopify:::$default:::${variantId}`
          }
        }
      }
    }
  }

  console.log('[Klaviyo BIS API] Payload prepared:', JSON.stringify(payload).substring(0, 100) + '...');

  if (!window.themeVariables || !window.themeVariables.klaviyo || !window.themeVariables.klaviyo.companyId) {
    console.error('[Klaviyo BIS API] Missing Klaviyo company ID in themeVariables');
    return;
  }

  const companyId = window.themeVariables.klaviyo.companyId;
  console.log('[Klaviyo BIS API] Using company ID:', companyId);

  var requestOptions = {
      method: 'POST',
      headers: {"Content-Type": "application/json", "Revision": formattedDate},
      body: JSON.stringify(payload),
  };

  console.log('[Klaviyo BIS API] Sending request to Klaviyo API');

  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, requestOptions)
      .then(result => {
        console.log('[Klaviyo BIS API] Response status:', result.status);

        // Check if the response is successful (status 202)
        const isSuccess = result.status === 202;

        if(isSuccess) {
          console.log('[Klaviyo BIS API] Subscription successful');

          // Support both old and new implementations
          let successMsg = document.querySelector('.success__msg');
          if(successMsg) {
            successMsg.style.display = 'flex';
          }
        } else {
          console.warn('[Klaviyo BIS API] Unexpected response status:', result.status);
          result.json().then(data => {
            console.error('[Klaviyo BIS API] Error details:', data);
          }).catch(() => {
            console.log('[Klaviyo BIS API] No JSON response body');
          });
        }

        // Call the callback function if it exists
        if (typeof window.handleBisResponse === 'function') {
          console.log('[Klaviyo BIS API] Calling response handler with success:', isSuccess);
          window.handleBisResponse(isSuccess);
        }
      })
      .catch(error => {
        console.error('[Klaviyo BIS API] Request failed:', error);

        // Call the callback function with failure if it exists
        if (typeof window.handleBisResponse === 'function') {
          console.log('[Klaviyo BIS API] Calling response handler with failure');
          window.handleBisResponse(false);
        }
      });
}
function updateBisBundleUrl(email, sku_id, url){
  const bisvalue = `${sku_id}__${url}`;
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/vnd.api+json',
      revision: '2025-04-15',
      'content-type': 'application/vnd.api+json'
    },
    body: JSON.stringify({
      "data": {
          "type": "profile",
          "attributes": {
              "email": email
          },
          "meta": {
              "patch_properties": {
                  "append": {
                      "BiS": bisvalue
                  }
              }
          }
      }
    })
  };

  if (!window.themeVariables || !window.themeVariables.klaviyo || !window.themeVariables.klaviyo.companyId) {
    console.error('[Klaviyo BIS API] Missing Klaviyo company ID in themeVariables');
    return;
  }
  fetch(`https://a.klaviyo.com/client/profiles?company_id=${window.themeVariables.klaviyo.companyId}`, options)
    .then(res => res.json())
    .then(res => console.log("[Klaviyo BIS Bundle API]: ", res))
}